import AOS from 'aos';
import 'aos/dist/aos.css';

document.addEventListener('DOMContentLoaded', _=> {
    if(document.querySelector('[data-aos]')) {
        AOS.init({
            duration: 1000,
            mirror: false,
            // once: true 
        });
        AOS.refresh();
    }
})


window.addEventListener('load', () => {
    AOS.refresh();
});
